/**
 * Shared sign-out sequence for the location-session gate screens
 * (GroupPicker — the one deliberate exit, Task 7) — writes a 'signed_out'
 * audit event, signs out of Supabase auth, and clears the location session
 * localStorage so the next login starts clean. `signOut` is passed in
 * (from `useAuth()`) rather than imported here so the caller keeps
 * ownership of the hook / its own loading state.
 */

import { STORAGE_KEY } from '../LocationSessionContext';
import { locationSessionService } from '../services/locationSessionService';

export async function signOutLocation(signOut: () => Promise<void>, locationCode: string): Promise<void> {
  try {
    await locationSessionService.recordEvent({ event: 'signed_out', locationCode, group: null, teacher: null });
  } catch (err) {
    // Sign-out must never be trapped by an audit-write failure — this is
    // the one deliberate, documented exception to fail-loudly (Task 8):
    // log loudly and proceed with the sign-out regardless.
    console.error('signOutLocation: failed to record signed_out audit event', err);
  }
  await signOut();
  localStorage.removeItem(STORAGE_KEY);
}
